<template>
  <el-dialog
    class="edit-contract-dialog common-dialog"
    :close-on-click-modal="false"
    :visible.sync="dialogVisible"
    :before-close="handleCancel"
    :title="deployTit"
  >
    <el-form
      :model="dataForm"
      :label-position="position"
      :rules="editRule"
      :label-width="`${adaptationVars.formLabelWidth}px`"
    >
      <el-form-item label="合约名称" prop="contractName">
        <el-input v-model="dataForm.contractName" disabled></el-input>
      </el-form-item>
      <el-form-item label="状态" prop="ContractStatus">
        <el-input v-model="dataForm.ContractStatus" disabled></el-input>
      </el-form-item>
      <el-form-item label="当前版本" prop="contractVersion">
        <el-input v-model="dataForm.contractVersion" disabled></el-input>
      </el-form-item>
      <el-form-item label="虚拟机类型" prop="runtimeType">
        <el-select
          v-model="dataForm.runtimeType"
          placeholder="请选择"
          class="auto-width"
          disabled
          @change="handleChange"
        >
          <el-option
            v-for="ele in options"
            :key="parseInt(ele.value)"
            :label="ele.label"
            :value="parseInt(ele.value)"
          >
          </el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="额外信息">
        <el-input v-model="dataForm.extractInfo" disabled></el-input>
      </el-form-item>
      <el-form-item label="合约调用方法" prop="methods">
        <operate-param ref="methodParam"></operate-param>
      </el-form-item>
    </el-form>
    <div slot="footer" class="dialog-footer">
      <el-button @click="handleCancel">取消</el-button>
      <el-button type="primary" @click="editContract()">确定</el-button>
    </div>
  </el-dialog>
</template>

<script>
import adaptation from '@/mixins/adaptation'
export default {
  name: 'EditContract',
  mixins: [adaptation],
  adaptationVarsDefine: {
    formLabelWidth: 100
  },
  data() {
    let validateMethods = (rule, value, callback) => {
      let condition = this.$refs.methodParam.validateParam()
      if (condition) {
        callback()
      } else {
        callback(new Error('请输入合约调用方法'))
      }
    }
    return {
      dialogVisible: false,
      deployTit: '编辑合约',
      position: 'right',
      resize: 'none',
      editRule: {
        contractName: [{ required: true, message: '请输入合约名称', trigger: 'blur' }],
        contractVersion: [{ required: true, message: '请输入合约版本', trigger: 'blur' }],
        runtimeType: [{ required: true, message: '请选择虚拟机类型', trigger: 'blur' }],
        file: [{ required: true, message: '请选择合约文件', trigger: 'blur' }],
        evmAbiSaveKey: [{ required: true, message: '请选择ABI文件', trigger: 'blur' }],
        ContractStatus: [{ required: true, message: '请输入合约状态', trigger: 'blur' }],
        methods: [{ validator: validateMethods, trigger: 'change' }]
      },
      dataForm: {
        chainId: '',
        contractName: '',
        contractVersion: '',
        ContractStatus: '',
        extractInfo: '',
        methods: [],
        runtimeType: 2,
        evmAbiSaveKey: '',
        parameters: []
      },
      options: [],
      showAbi: false,
      sendForm: {
        evmAbiSaveKey: '',
        id: '',
        methods: []
      },
      adaptationVars: {
        formLabelWidth: 100
      }
    }
  },
  mounted() {
    this.getOptions()
  },
  methods: {
    getOptions() {
      //获取虚拟机类型
      this.$apis.chain.getRuntimeTypeList().then(res => {
        if (res.data) {
          let arr = res.data.items
          let newArr = arr.map(ele => {
            let item = {
              label: ele.RuntimeTypeName,
              value: ele.RuntimeTypeType
            }
            return item
          })
          this.options = newArr
        }
      })
    },
    handleCancel() {
      this.dialogVisible = false
    },
    handleOpen(data) {
      let statusArr = [
        '合约初始化',
        '合约升级初始化',
        '合约初始化部署失败',
        '合约初始化合约成功',
        '合约升级失败',
        '合约升级成功',
        '合约冻结失败',
        '合约冻结成功',
        '合约解冻失败',
        '合约解冻成功',
        '合约注销失败',
        '合约注销成功'
      ]
      this.sendForm.id = data.id
      this.sendForm.evmAbiSaveKey = data.EvmAbiSaveKey || ''
      this.dataForm.contractName = data.name
      this.dataForm.contractVersion = data.version
      this.dataForm.runtimeType = data.runtimeType
      this.dataForm.ContractStatus = statusArr[data.ContractStatus]
      //处理额外信息
      if (data.MgmtParams) {
        let array = JSON.parse(data.MgmtParams)
        this.dataForm.extractInfo = array
          .map(ele => {
            return ele.key
          })
          .join(',')
      }
      //处理调用方法
      if (data.Methods) {
        let array = JSON.parse(data.Methods)
        this.dataForm.parameters = array.map(ele => {
          let item = {
            key: ele.methodName,
            value: ele.methodKey
          }
          return item
        })
      }
      this.dialogVisible = true
      if (this.$utils.isEmpty(this.dataForm.parameters)) {
        this.$nextTick(() => {
          this.$refs.methodParam.updateParam([{ key: '', value: '' }])
        })
      } else {
        this.$nextTick(() => {
          this.$refs.methodParam.updateParam(this.dataForm.parameters)
        })
      }
    },
    handleChange(val) {
      if (val === 5) {
        this.showAbi = true
      } else {
        this.$refs.abi.clear()
        this.showAbi = false
      }
    },
    editContract() {
      let newMethod = this.$refs.methodParam.getParam()
      this.sendForm.methods = newMethod.map(elem => {
        let item = {
          methodKey: elem.value,
          methodName: elem.key
        }
        return item
      })
      this.$apis.chain.modifyContract(this.sendForm).then(res => {
        if (res) {
          this.$message.success('编辑成功')
          this.handleCancel()
          this.$emit('update:list')
        }
      })
    }
  }
}
</script>

<style scoped lang="scss">
@import '@/styles/variables/theme';
@import '@/styles/variables/adaptation';

@include theme('edit-contract-dialog', (), ());
.edit-contract-dialog.common-dialog {
  @include adaptation(());
  /deep/ .el-dialog {
    width: var(--common-dialog-medium-width);
  }

  .el-form {
    margin-right: var(--common-dialog-form-margin-right);
  }
}
</style>
